module.exports = __webpack_public_path__ + "static/fonts/Poppins-Medium.bf59c687.ttf";